import { type FC, type ReactNode } from 'react'

import { IconCheck } from '@redteclab/icons'

export const RedPointsBenefitDialogRow: FC<{
  text: ReactNode
}> = ({ text }) => {
  return (
    <div className="mb-3 flex flex-row items-center">
      <IconCheck className="ml-2 size-8 text-dark-brand" />
      <p className="ml-2 w-fit text-dark-primary-strong">{text}</p>
    </div>
  )
}
